import { useState } from "react";
import { ArrowDownWideNarrow } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Panel, Empty } from "@/components/PageHeader";
import { eur, num } from "@/lib/api";

const SORTS = [["penetration", "Penetrazione"], ["spend", "Spesa"], ["qty", "Quantità"]];

export const BasketTable = ({ products, threshold, single, months }) => {
  const [sort, setSort] = useState("penetration");
  const rows = [...products].sort((a, b) => b[sort] - a[sort]);
  const max = Math.max(...products.map((p) => p.penetration), 1);

  return (
    <Panel title="Prodotti più acquistati" className="min-w-0" testId="basket-products-panel" action={
      <div className="flex flex-wrap items-center gap-1 text-xs">
        <ArrowDownWideNarrow className="h-3.5 w-3.5 text-slate-400" />
        {SORTS.map(([k, l]) => (
          <button key={k} data-testid={`basket-sort-${k}`} onClick={() => setSort(k)}
            className={`rounded-md px-2 py-1 transition-colors ${sort === k ? "bg-slate-900 text-white" : "text-slate-500 hover:bg-slate-100"}`}>{l}</button>
        ))}
      </div>}>
      {rows.length === 0 ? <Empty text="Nessun acquisto nel periodo selezionato." /> : (
        <div className="max-h-[620px] overflow-auto">
          <Table data-testid="basket-products-table">
            <TableHeader><TableRow>
              <TableHead>Prodotto</TableHead>
              <TableHead className="w-40">{single ? "% scontrini" : "% clienti"}</TableHead>
              <TableHead className="text-right">{single ? "Acquisti/mese" : "Clienti"}</TableHead>
              <TableHead className="text-right">Q.tà</TableHead>
              <TableHead className="text-right">Spesa</TableHead>
              <TableHead className="text-right">Prezzo medio</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {rows.map((p) => {
                const core = p.penetration >= threshold;
                return (
                  <TableRow key={p.ean} data-testid="basket-product-row">
                    <TableCell>
                      <div className="flex items-center gap-2">
                        <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${core ? "bg-blue-600" : "bg-slate-200"}`} />
                        <span className="text-sm font-medium text-slate-800">{p.name}</span>
                      </div>
                      <div className="pl-3.5 font-mono text-[10px] text-slate-400">{p.ean} · {p.share.toLocaleString("it-IT")}% della spesa</div>
                    </TableCell>
                    <TableCell>
                      <div className="flex items-center gap-2">
                        <div className="h-1.5 flex-1 rounded-full bg-slate-100"><div className={`h-1.5 rounded-full ${core ? "bg-blue-600" : "bg-slate-400"}`} style={{ width: `${(p.penetration / max) * 100}%` }} /></div>
                        <span className="w-10 text-right font-mono text-xs">{p.penetration.toLocaleString("it-IT")}%</span>
                      </div>
                    </TableCell>
                    <TableCell className="text-right font-mono text-xs">{single ? (p.receipts / months).toLocaleString("it-IT", { maximumFractionDigits: 1 }) : num(p.clients)}</TableCell>
                    <TableCell className="text-right font-mono text-xs">{num(Math.round(p.qty))}</TableCell>
                    <TableCell className="text-right font-mono text-xs">{eur(p.spend)}</TableCell>
                    <TableCell className="text-right font-mono text-xs">{eur(p.avg_price)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      )}
    </Panel>
  );
};
